import Cookies from 'js-cookie'

export function createCookie (name, value, daysToExpire = 365) {
  Cookies.set(name, value, { expires: daysToExpire })
}
export function parseCookie (name) {
  return Cookies.getJSON(name)
}
export function deleteCookie (name) {
  return Cookies.remove(name)
}
